// extracted by mini-css-extract-plugin
export default {"overlay":"Ny-z","bodyOpen":"Oy-z","content":"Py-z","header":"Qy-z","close":"Ry-z","closeNoHeading":"Sy-z"};